import React, { useRef } from "react";
import { Box } from '@curves/ui-base';
import useEChart from "@Util/hook/useEChart";
import { monthFormatter } from "@Local/Dashboard/dashboard.util";
import { MAIN_COLOR_PALETTE, MAIN_LINEAR_COLOR_PALETTE } from "@Local/Dashboard/dashboard.config";
import { graphic } from "echarts";

/********* 會員管道來源 *********/
const MeasureTrendAreaChart = React.forwardRef((props, ref) => {
	const chartDomRef = useRef(null);
	const { sourceData } = props;

	const { title = '', subtitle = '', xAxis = [], yAxis = [], data = [] } = sourceData;

	const series = yAxis.map((item, index) => ({
		name: item,
		type: "line",
		stack: "total",
        symbolSize: 8,
		lineStyle: {
			width: 0,
		},
		areaStyle: {
			opacity: 0.9,
			color: new graphic.LinearGradient(0, 0, 0, 1, [
				{ offset: 0, color: MAIN_LINEAR_COLOR_PALETTE[index][0] },
				{ offset: 1, color: MAIN_LINEAR_COLOR_PALETTE[index][1] },
			]),
		},
		emphasis: {
			focus: "series",
		},
		data: data[index],
	}));

	const isLoading = data.length === 0;

	const option = {
		title: {
			left: 24,
			top: 20,
			text: title,
			textStyle: {
				fontSize: 20,
				fontWeight: 600,
				color: "#1F2937",
			},
			subtext: subtitle,
			subtextStyle: {
				fontSize: 14,
				color: "#64748B",
				padding: [8, 0, 0, 0],
			},
		},

		color: MAIN_COLOR_PALETTE,

		grid: {
			left: 60,
			right: 40,
			top: 80,
			bottom: 60,
		},

		tooltip: {
			trigger: "axis",
			alwaysShowContent: false,
			triggerOn: "click",
		},

		xAxis: [
			{
				type: "category",
				data: xAxis,
				axisLabel: {
					fontSize: 12,
					color: "#666",
					margin: 8,
					// interval: 0,
					// rotate: -30,
					formatter: monthFormatter,
				},
				axisTick: { show: false },
				axisLine: { show: true },
				splitLine: { show: false },
			},
		],

		yAxis: {
			type: "value",
		},

        series: series,

		// series: [
        //     ...series,
        //     {
        //         type: 'line',
        //         data: [...data],
        //         symbolSize: 10,
        //     },
        // ],

		dataZoom: [
			{
				disabled: xAxis.length <= 7,
				type: "inside",
				xAxisIndex: 0,
				filterMode: "none",
				zoomLock: true,
				zoomOnMouseWheel: false,
				moveOnMouseMove: true,
				moveOnMouseWheel: true,
				preventDefaultMouseMove: true,
				start: xAxis.length <= 7 ? 0 : xAxis.length <= 14 ? 40 : 60,
				end: 100,
			},
			{
				show: xAxis.length > 7,
				type: "slider",
				height: 8,
				bottom: 8,
				showDataShadow: false,
				showDetail: false,
				handleSize: 20,
				handleStyle: {
					color: "rgba(91,15,115,0.2)",
					borderWidth: 0,
				},
				backgroundColor: "#E5E7EB",
				fillerColor: "rgba(91,15,115,0.4)",
				borderColor: "transparent",
				moveHandleStyle: {
					color: "rgba(91,15,115,0.4)",
				},
				emphasis: {
					moveHandleStyle: {
						color: "rgba(91,15,115,0.8)",
					},
				},
			},
		],
	};

	useEChart(chartDomRef, option);

	return <Box style={{ width: "100%", height: "100%" }}>{!isLoading && <Box ref={chartDomRef} style={{ width: "100%", height: "100%" }}></Box>}</Box>;
});

export default MeasureTrendAreaChart;
